import React, {useRef, useState} from 'react';
import * as Yup from "yup";
import {connect, useSelector} from "react-redux";
import Switch from "react-bootstrap-switch";
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { ErrorMessage, useForm } from "react-hook-form";

import AdmissionLangs from "./_langs";
import {
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {
    INTERNATIONAL,
    MAX_NAME,
    REQUIRED
} from "../../../components/i18n/i18n";
import { MAX_NAME_SIZE } from "../../../components/menu-flower/constants";
import { formatterService } from "../../../jwt/_helpers/formatter";
import { FL_ALLOWED_TO_BUY, FL_CODE, FL_IMAGE, FL_ORDER, FL_PRIMARY_COLOR, FL_SECONDARY_COLOR, FL_STATUS } from "../../../components/i18n/formLabels";
import {PH_CODE, PH_IMAGE} from "../../../components/i18n/placeHolders";
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import {getStateByPath} from "../../../redux/selectors";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {admissionService} from "../../../jwt/_services/configuration/admissionService";
import {GenericButton} from "../../../components/buttons/customButtons";
import Separator from "../../../components/Separator";
import ActivitySection from "./ActivitySection/ActivitySection";

const AdmissionForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { app, udn, editMode, domainObject} = componentState?.data;

    // const { dataToEdit, editMode, loading, disableInputs, saveSuccess } = props.admissionState
    const [status, setStatus] = useState(domainObject?.status !== undefined ? domainObject.status : true);
    const [allowBuy, setAllowBuy] = useState(domainObject?.allowBuy !== undefined ? domainObject.allowBuy : true);
    const [langs, setlangs] = useState(domainObject?.langs || []);
    const translatableLangs = domainObject?.translatedLangs || []

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required(REQUIRED).max(MAX_NAME_SIZE, MAX_NAME),
        image: Yup.string().required(REQUIRED),
        showOrder: Yup.string().required(REQUIRED),
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            code: domainObject?.code,
            showOrder: domainObject?.showOrder,
            image: domainObject?.image,
            primaryColorHex: domainObject?.primaryColorHex,
            secundaryColorHex: domainObject?.secundaryColorHex,
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            fbDataBase: { id : app?.fbDataBase?.id },
            item: {
                ...data,
                primaryColorHex: data.primaryColorHex,
                primaryColorRGB: formatterService.hexToRGB(data.primaryColorHex),
                secundaryColorHex: data.secundaryColorHex,
                secundaryColorRGB: formatterService.hexToRGB(data.secundaryColorHex),
                status: status,
                allowBuy: allowBuy,
                udn: { id : udn?.id },
                langs: langs,
            }
        };

        if (!editMode)
            genericIndexedActions.save(path, admissionService, dataRequest)
        else {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, admissionService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.onClose()
    }

    return  <>
        <Form onSubmit={ handleSubmit(onSubmit) }>
            <Card className={'card-modal-medium'}>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <>
                        <h2 className={'card-modal-title'} > { (udn?.value || '') + ' / Entradas / ' + (domainObject?.title || domainObject?.name || '') }</h2>
                        <br />
                        <h5 className={'card-modal-uid'} > { '     uid: ' + (domainObject?.uid || '') }</h5>
                    </>
                    <div className={'top-right'}>
                        <GenericButton
                            style={'table'}
                            icon={'fa-save'}
                            toolTip={TT_SAVE}
                            permission={'add'}
                            type={'submit'}
                        />
                        {
                            editMode && <>
                                <GenericTableButton
                                    toolTip={TT_HISTORY}
                                    icon={'fa-clock'}
                                    permission={'search'}
                                    onClick={showHistory}
                                />
                            </>
                        }
                        <Separator/>
                        <GenericButton
                            style={'danger-secondary'}
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={closeForm}
                        />
                    </div>
                </CardTitle>
                <CardBody className={'card-body-modal'}>
                    <Row>
                        <Col md={!editMode ? "12" : "6"}>
                            <Row>
                                <Col md="8">
                                    <FormGroup>
                                        <Label>{FL_CODE}</Label>
                                        <Input type="text" name="code"
                                               placeholder={PH_CODE}
                                               innerRef={register}
                                               className={(errors.code ? ' is-invalid' : '')}
                                        />
                                        <ErrorMessage errors={errors} name="code" component="div" className="invalid-feedback"/>
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <Label>{FL_STATUS}</Label>
                                        <br/>
                                        <Switch
                                            animate={true}
                                            offText={"No"}
                                            onText={"Si"}
                                            value={status}
                                            onChange={ _ => setStatus(!status) }
                                        />
                                    </FormGroup>
                                </Col>

                                <Col md="4">
                                    <FormGroup>
                                        <Label>{FL_IMAGE}</Label>
                                        <Input type="text" name="image"
                                               placeholder={PH_IMAGE}
                                               innerRef={register}
                                               className={(errors.image ? ' is-invalid' : '')}
                                        />
                                        <ErrorMessage errors={errors} name="image" component="div" className="invalid-feedback"/>
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <Label>{FL_ORDER}</Label>
                                        <br/>
                                        <Input type="number" name="showOrder"
                                               innerRef={register}
                                               min="0"
                                               className={(errors.showOrder ? ' is-invalid' : '')}
                                        />
                                        <ErrorMessage errors={errors} name="showOrder" component="div" className="invalid-feedback"/>
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <Label>{FL_ALLOWED_TO_BUY}</Label>
                                        <br/>
                                        <Switch
                                            animate={true}
                                            offText={"No"}
                                            onText={"Si"}
                                            value={allowBuy}
                                            onChange={ _ => setAllowBuy(!allowBuy) }
                                        />
                                    </FormGroup>
                                </Col>


                                <Col md="4">
                                    <FormGroup>
                                        <Label >{FL_PRIMARY_COLOR}</Label>
                                        <Input type="color"
                                               name="primaryColorHex"
                                               innerRef={register}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <Label >{FL_SECONDARY_COLOR}</Label>
                                        <Input type="color"
                                               name="secundaryColorHex"
                                               innerRef={register}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={!editMode ? "0" : "6"}>
                            {
                                editMode &&
                                <ActivitySection
                                    path={path }
                                />
                            }
                        </Col>
                    </Row>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="fas fa-language mr-2"/>
                        { INTERNATIONAL }
                    </CardTitle>
                    <CardBody>
                        <AdmissionLangs
                            langs={langs}
                            setLangs={setlangs}
                            translatableLangs={translatableLangs}
                        />
                    </CardBody>
                </CardBody>
            </Card>
        </Form>

        {
            showModal && <LogHistoryModal
                ref={ modalRef }
                item={ domainObject }
            />
        }
    </>
}

const mapStateToProps = _ => ({})

const mapActionsToProps = ({
})

export default connect(mapStateToProps, mapActionsToProps)(AdmissionForm)